import { gql } from '@apollo/client';
import {
  MasterEntityBasicField,
  RiskListFields,
} from '../customers/fragment';
import { UserIdentification } from '../user/fragments';

const CollectionMasterEntityFragment = gql`
  fragment CollectionMasterEntityFragment on MasterEntityType {
    ...MasterEntityBasicField
    riskBlacklist {
      ...RiskListFields
    }
    debtor {
      id
      ratifies
      ratificationInformation {
        id
        comment
      }
      collectionPriority(ownerId: $inCollection) {
        id
        priority {
          id
          value
        }
      }
      collector {
        ...UserIdentification
      }
    }
  }
  ${MasterEntityBasicField}
  ${UserIdentification}
  ${RiskListFields}
`;

export default CollectionMasterEntityFragment;
